import { TRANSFORMERS } from '@lexical/markdown';
import { INS } from '../../../SubjectViewer/Modules/AITools/ImpressionEditor/MarkdownEditor/transformers';
import { CHART } from './chart';
import { HORIZONTAL_RULE } from './horizontalRule';

export { CHART } from './chart';
export { HORIZONTAL_RULE } from './horizontalRule';

export const DEFAULT_TRANSFORMERS = [HORIZONTAL_RULE, ...TRANSFORMERS, INS];

/**
 * Adds chart blocks on top of the defaults. CHART creates a ChartNode, so this
 * list is only safe for editors that also register ChartNode — currently just
 * LexicalReadOnlyMarkdownViewer. Keeping it out of DEFAULT_TRANSFORMERS means
 * generic MarkdownEditor consumers (which pair with DEFAULT_NODES) neither
 * crash on an unregistered node nor pay for Victory.
 */
export const VIEWER_TRANSFORMERS = [CHART, ...DEFAULT_TRANSFORMERS];
